import PropTypes from 'prop-types'
import React from 'react'
import { Nav } from 'reactstrap'
import NavItems from './NavItems'

const PillNavs = ({ navs, startNav, setCurrentNav }) => (
  <>
    <Nav
      className="nav-pills-info nav-pills-icons justify-content-center"
      pills
      role="tablist"
    >
      <NavItems
        navs={navs}
        startNav={startNav}
        setCurrentNav={setCurrentNav}
        withIcon
      />
    </Nav>
  </>
)

PillNavs.propTypes = {
  navs: PropTypes.array,
  startNav: PropTypes.string,
  setCurrentNav: PropTypes.func,
}

export default PillNavs
